import * as angular from 'angular';

"use strict";

angular.module('BlocworxModule')
       .controller('ClickController', ClickController);

ClickController.$inject = ['$scope', 'ScopeAndLocal'];

function ClickController($scope, ScopeAndLocal) {

    let vm = this;

    /**
     * Constructor class.
     */
    vm.$onInit = function () {
        try {

        } catch (e) {
            console.log(e);
        }
    }
}

export default ClickController;